import { FC, ReactNode } from 'react';
import { Box, Stack } from '@mui/material';

import { IconWrapper } from './ServiceCardContentLayout.styles';

interface IServiceCardContentLayoutProps {
	icon: ReactNode | null;
	leftContent: ReactNode;
	rightContent: ReactNode;
	bottomContent?: ReactNode;
}

export const ServiceCardContentLayout: FC<IServiceCardContentLayoutProps> = ({
	icon,
	leftContent,
	rightContent,
	bottomContent,
}) => {
	return (
		<Stack flexDirection="column" sx={{ width: '100%' }}>
			<Stack
				flexDirection="row"
				alignItems="center"
				gap={1}
				sx={{ width: '100%' }}
			>
				{icon && <IconWrapper>{icon}</IconWrapper>}

				<Box sx={{ flex: 1, width: '100%' }}>
					<Stack
						direction="row"
						alignItems="stretch"
						justifyContent="space-between"
						sx={{ width: '100%' }}
						gap={2}
					>
						{leftContent}
						{rightContent}
					</Stack>
				</Box>
			</Stack>

			{bottomContent}
		</Stack>
	);
};
